import { Component, ComponentFactoryResolver, HostListener, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import * as Chartist from 'chartist';
import { ChartType, ChartEvent } from "ng-chartist";
import ChartistTooltip from 'chartist-plugin-tooltips-updated';
import { ApiService } from 'app/shared/services/api.service';
import { data } from 'app/shared/data/smart-data-table';
import { DynamicDetailData } from 'app/dashboard/dashboard1/dashboard1.component';
import { DynamicDetailComponent } from 'app/pages/full-pages/admin/dynamic-detail/dynamic-detail.component';


declare var require: any;

// const data: any = require('../../../../../shared/data/chartjs.json');
export interface Chart {
  type: ChartType;
  data: Chartist.IChartistData;
  options?: any; 
  responsiveOptions?: any;
  events?: ChartEvent;
  // plugins?: any;
}
@Component({
  selector: 'app-new-dashboard',
  templateUrl: './new-dashboard.component.html',
  styleUrls: ['./new-dashboard.component.scss']
})
export class NewDashboardComponent implements OnInit {
  usersLength:any;
  courseLength:any;
  studentLength:any;
  businessLength:any;
  courseCount:any;
  user:any
  @ViewChild('dynamicContainer', { read: ViewContainerRef, static: false }) dynamicContainer: ViewContainerRef;
  guideline_data
  row_data
  default_courses:any=[]
  constructor(private apiService:ApiService,private resolver: ComponentFactoryResolver) { 
    this.user =JSON.parse(localStorage.getItem('user'))
  }
  transactionData = [];

  // view: any[] = [700, 400];
  view: [number, number] = [window.innerWidth * 0.9, 400];


  // options
  showXAxis = true;
  showYAxis = true;
  gradient = false;
  showLegend = false;
  showXAxisLabel = true;
  showYAxisLabel = true;
  yAxisLabel = 'Amount';

  colorScheme = {
    domain: ['#C7B42C', '#5AA454', '#A10A28', '#AAAAAA']
  };

  barChartData: any[] = [];
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.view = [event.target.innerWidth * 0.9, 400];
  }
  ngOnInit(): void {
    this.view = [window.innerWidth * 0.9, 400];
    this.filterSetting('Student Dashboard')
    this.getAllRecord()
    this.getDefaultCourseList()
    this.getTransactionsByUserId()

  }

  
  getAllRecord(){
    this.apiService.getAllRecords().subscribe((res:any)=>{
      this.usersLength = res?.data?.UserCount
      this.studentLength = res?.data?.StudentCount
      this.businessLength = res?.data?.BusinessCount
      this.courseCount = res?.data?.CourseCount
  
    })
  }
 
  getTransactionsByUserId() {
    this.apiService.getTransactionUserById(this.user.id).subscribe((res: any) => {
      this.transactionData = res.data;
      this.updateChartData();
    })
  }
  updateChartData() {
    this.barChartData = [
      {
        "name": "Net Fee",
        "value": this.transactionData[0].net_amount
      },
      {
        "name": "Total Paid",
        "value": this.transactionData[0].total_paid
      },
      {
        "name": "Pending Fee",
        "value": this.transactionData[0].pendingAmount
      }
    ];
  }
  onResized(event: any) {
    setTimeout(() => {
      this.fireRefreshEventOnWindow();
    }, 300);
  }
  fireRefreshEventOnWindow = function () {
    var evt = document.createEvent("HTMLEvents");
    evt.initEvent("resize", true, false);
    window.dispatchEvent(evt);
  }

  WidgetlineChart: Chart = {
    type: 'Line', data: data['Dashboard1_WidgetlineChart'],
    options: {
      axisX: {
        showGrid: false,
        showLabel: false,
        offset: 0
      },
      axisY: {
        showGrid: false,
        low: 40,
        showLabel: false,
        offset: 0
      },
      plugins: [
        ChartistTooltip({
          appendToBody: true,
          currency: '$',
          pointClass: 'ct-point-regular'
        })
      ],
      lineSmooth: Chartist.Interpolation.cardinal({
        tension: 0
      }),
      fullWidth: true
    },
    events: {
      draw(data: any): void {
        if (data.type === 'point') {
          var circle = new Chartist.Svg('circle', {
            cx: data.x,
            cy: data.y,
            r: 4,
            'ct:value': data.value.y,
            'ct:meta': data.meta,
            style: 'pointer-events: all !important',
            class: 'ct-point-regular'
          });
          data.element.replace(circle);
        }
      }
    }
  };
  // Line chart configuration Ends

    // line chart configuration Starts
    WidgetlineChart1: Chart = {
      type: 'Line', data: data['Dashboard1_WidgetlineChart1'],
      options: {
        axisX: {
          showGrid: false,
          showLabel: false,
          offset: 0
        },
        axisY: {
          showGrid: false,
          low: 40,
          showLabel: false,
          offset: 0
        },
        plugins: [
          ChartistTooltip({
            appendToBody: true,
            currency: '$',
            pointClass: 'ct-point-regular'
          })
        ],
        lineSmooth: Chartist.Interpolation.cardinal({
          tension: 0
        }),
        fullWidth: true
      },
      events: {
        draw(data: any): void {
          if (data.type === 'point') {
            var circle = new Chartist.Svg('circle', {
              cx: data.x,
              cy: data.y,
              r: 4,
              'ct:value': data.value.y,
              'ct:meta': data.meta,
              style: 'pointer-events: all !important',
              class: 'ct-point-regular'
            });
            data.element.replace(circle);
          }
        }
      }
    };
    // Line chart configuration Ends

      // line chart configuration Starts
  WidgetlineChart2: Chart = {
    type: 'Line', data: data['Dashboard1_WidgetlineChart2'],
    options: {
      axisX: {
        showGrid: false,
        showLabel: false,
        offset: 0
      },
      axisY: {
        showGrid: false,
        low: 40,
        showLabel: false,
        offset: 0
      },
      plugins: [
        ChartistTooltip({
          appendToBody: true,
          currency: '$',
          pointClass: 'ct-point-regular'
        })
      ],
      lineSmooth: Chartist.Interpolation.cardinal({
        tension: 0
      }),
      fullWidth: true
    },
    events: {
      draw(data: any): void {
        if (data.type === 'point') {
          var circle = new Chartist.Svg('circle', {
            cx: data.x,
            cy: data.y,
            r: 4,
            'ct:value': data.value.y,
            'ct:meta': data.meta,
            style: 'pointer-events: all !important',
            class: 'ct-point-regular'
          });
          data.element.replace(circle);
        }
      }
    }
  };
  // Line chart configuration Ends

    // line chart configuration Starts
    WidgetlineChart3: Chart = {
      type: 'Line', data: data['Dashboard1_WidgetlineChart3'],
      options: {
        axisX: {
          showGrid: false,
          showLabel: false,
          offset: 0
        },
        axisY: {
          showGrid: false,
          low: 40,
          showLabel: false,
          offset: 0
        },
        plugins: [
          ChartistTooltip({
            appendToBody: true,
            currency: '$',
            pointClass: 'ct-point-regular'
          })
        ],
        lineSmooth: Chartist.Interpolation.cardinal({
          tension: 0
        }),
        fullWidth: true
      },
      events: {
        draw(data: any): void {
          if (data.type === 'point') {
            var circle = new Chartist.Svg('circle', {
              cx: data.x,
              cy: data.y,
              r: 4,
              'ct:value': data.value.y,
              'ct:meta': data.meta,
              style: 'pointer-events: all !important',
              class: 'ct-point-regular'
            });
            data.element.replace(circle);
          }
        }
      }
    };
    createDynamicComponent(data:DynamicDetailData) {
      this.row_data =data
      // Create a factory for the dynamic component
      const factory = this.resolver.resolveComponentFactory(DynamicDetailComponent);
  
      // Create an instance of the dynamic component
      const componentRef = factory.create(this.dynamicContainer.injector);
  
      // Set the data for the dynamic component
      componentRef.instance.data = data;
  
      // Insert the dynamic component into the view container
      this.dynamicContainer.insert(componentRef.hostView);
    }
  
    filterSetting(data){
      this.apiService.searchSettings(data).subscribe((res:any)=>{
        if(res?.statusCode === 200){
          this.guideline_data = res?.data?.items[0]
          this.createDynamicComponent(this.guideline_data)
        }
      })
    
  }
  getDefaultCourseList(){
    this.apiService.getDefaultCourse().subscribe((res:any)=>{
      this.default_courses = res?.data
    })
  }
}

